import _Object$freeze from "@babel/runtime-corejs3/core-js/object/freeze";
import _Object$create from "@babel/runtime-corejs3/core-js/object/create";
export default _Object$freeze(_Object$create(null));